import { coreMessages, type AppLocale } from './base-messages';

export const fr: AppLocale = {
  ...coreMessages,
  dataTable: {
    rowModeLabel: 'Row display',
    rowModeEllipsis: 'Truncate (…)',
    rowModeScroll: 'Single line + horizontal scroll',
    rowModeWrap: 'Wrap lines',
    columnsLabel: 'Columns',
    reorderColumnHint: 'Drag the handle to move this column',
    resetThisTablePrefs: 'Reset this table',
    resetThisTablePrefsTitle: 'Clear saved layout for this table only (row mode, columns, order, widths). Does not change your global user settings.',
    dataOperationsLabel: 'Opérations de données',
    operationExportExcel: 'Télécharger Excel',
    operationDownloadTemplate: 'Télécharger le modèle',
    operationUploadTemplate: 'Téléverser le modèle',
    operationImportHistory: 'Historique des importations',
    operationFieldDictionary: 'Dictionnaire des champs',
    operationUnsupported: 'Ce tableau ne prend pas en charge cette opération.',
    operationNoPermission: 'Vous n\'avez pas l\'autorisation pour cette opération.',
    operationNotReady: 'Cette opération n\'est pas encore prête.',
    customFieldColumnsSectionLabel: 'Champs personnalisés',
    importModalTitle: 'Importer le modèle',
    importChooseFile: 'Choisir un fichier CSV',
    importChooseFileHint: 'Remplissez puis importez le modèle téléchargé depuis ce tableau.',
    importNoFile: 'Aucun fichier sélectionné.',
    importSummary: 'Résumé de l\'import',
    importReadyRows: 'Lignes prêtes',
    importErrorRows: 'Lignes en erreur',
    importWarnings: 'Avertissements',
    importUnknownHeaders: 'Colonnes inconnues',
    importMissingRequiredHeaders: 'Colonnes obligatoires manquantes',
    importPreview: 'Aperçu',
    importSubmit: 'Démarrer l\'import',
    importCancel: 'Annuler',
    importParsing: 'Lecture du fichier...',
    importSubmitting: 'Import en cours...',
    importNoValidRows: 'Aucune ligne valide à importer.',
    importFailed: 'Échec de l\'import.',
    importSucceeded: 'Import terminé.',
    operationExportCsv: 'Télécharger CSV',
    operationExportPdf: 'Télécharger PDF',
    operationNoRows: 'Aucune ligne visible à exporter.',
    importUnknownHeader: 'Colonne inconnue : {header}',
    importMissingRequiredHeader: 'Colonne obligatoire manquante : {header}',
    importRequiredCell: '{header} est obligatoire.',
    importMaxRowsExceeded: 'Le fichier contient plus de {maxRows} lignes ; seules les {maxRows} premières ont été évaluées.',
    refreshLabel: 'Actualiser',
    focusModeEnterLabel: 'Cibler le tableau',
    focusModeFullscreenLabel: 'Passer en plein écran',
    focusModeExitLabel: 'Quitter le mode ciblé',
    horizontalScrollLabel: 'Faire défiler les colonnes du tableau',
    selectionModeLabel: 'Sélectionner des lignes',
    selectAllRowsLabel: 'Sélectionner toutes les lignes',
    selectRowLabel: 'Sélectionner la ligne',
    bulkSelectedLabel: '{count} sélectionnées',
    bulkActionsLabel: 'Actions groupées',
    tableSettingsLabel: 'Paramètres du tableau',
    appearanceSectionLabel: 'Apparence',
    columnsSectionLabel: 'Colonnes',
    rowActionsLabel: 'Actions de la ligne',
  },
  passwordReset: {
    title: 'Définir un nouveau mot de passe',
    description: 'Choisissez un nouveau mot de passe robuste que vous seul connaissez.',
    newPassword: 'Nouveau mot de passe',
    confirmPassword: 'Confirmer le nouveau mot de passe',
    passwordHelp: 'Utilisez au moins 12 caractères et au moins trois types parmi : minuscule, majuscule, chiffre et caractère spécial.',
    mismatch: 'Les mots de passe ne correspondent pas.',
    invalidLink: 'Le lien de réinitialisation est absent, invalide ou expiré.',
    submit: 'Mettre à jour le mot de passe',
    submitting: 'Mise à jour du mot de passe...',
    success: 'Votre mot de passe a été mis à jour. Vous pouvez maintenant vous connecter avec le nouveau mot de passe.',
    backToLogin: 'Retour à la connexion',
    requestTitle: 'Envoyer le lien de réinitialisation',
    requestDescription: 'Un lien à usage unique, valable 30 minutes, sera envoyé à l’adresse e-mail enregistrée de l’utilisateur. Le mot de passe actuel reste inchangé tant que le lien n’est pas utilisé.',
    requestSend: 'Envoyer le lien',
    requestSending: 'Envoi en cours...',
    requestSuccess: 'Le lien de réinitialisation a été accepté pour envoi.',
    requestError: 'Le lien de réinitialisation n’a pas pu être envoyé.',
    selfServiceOpen: 'Mot de passe oublié',
    selfServiceTitle: 'Mot de passe oublié',
    selfServiceDescription: 'Saisissez l’adresse e-mail de votre compte professionnel. Si elle correspond à un compte, un lien à usage unique valable 30 minutes sera envoyé.',
    selfServiceEmailLabel: 'E-mail',
    selfServiceSubmit: 'Demander le lien',
    selfServiceSubmitting: 'Envoi de la demande...',
    selfServiceAcknowledgement: 'Si cette adresse est enregistrée, un lien de réinitialisation sera envoyé. Vérifiez votre boîte de réception et vos courriers indésirables.',
    selfServiceClose: 'Fermer',
    selfServiceCancel: 'Annuler',
    selfServiceError: 'La demande n’a pas pu être traitée. Veuillez réessayer plus tard.',
    selfServiceRateLimited: 'Trop de demandes. Veuillez réessayer plus tard.',
  },
  relationshipGraph: {
    sourceColumn: 'Source',
    relationshipColumn: 'Relation',
    targetColumn: 'Enregistrement lié',
    showDetails: 'Afficher les détails',
    hideDetails: 'Masquer les détails',
    controlsLabel: 'Commandes de la carte',
    title: 'Carte des relations',
    diagramLabel: 'Relations de l’enregistrement',
    diagramHelp: 'Sélectionnez une carte pour examiner les liens enregistrés.',
    detailsTitle: 'Détails du dossier',
    connectionsTitle: 'Liens',
    noConnections: 'Aucun lien',
    loading: 'Chargement des relations…',
    forbidden: 'Vous n’avez pas accès à ces relations.',
    error: 'Impossible de charger les relations. Fermez puis réessayez.',
    empty: 'Cet enregistrement ne comporte aucun lien affichable.',
    invalid: 'Impossible de vérifier les relations. Fermez puis réessayez.',
    close: 'Fermer la carte des relations',
    zoomIn: 'Agrandir',
    zoomOut: 'Réduire',
    fitView: 'Ajuster la carte',
  },
  permissionPicker: {
    application: 'Application',
    module: 'Module',
    action: 'Action',
    permissions: 'Permissions',
    description: 'Description',
    selection: 'Sélection',
    sharedPermissions: 'Autorisations partagées',
    selectedPermissions: '{count} autorisations sélectionnées',
    selectedOnly: 'Sélectionnés uniquement',
    unselectedOnly: 'Non sélectionnés uniquement',
    selectedFirst: 'Sélectionnés en premier',
    noPermissions: 'Aucune permission',
  },
  errors: {
    ...coreMessages.errors,
    unknown: 'Une erreur inconnue s\'est produite',
    network: 'Impossible de se connecter au serveur. Veuillez vérifier votre connexion Internet.',
    timeout: 'Délai d\'attente dépassé. Veuillez réessayer.',
    badRequest: 'Requête invalide',
    unauthorized: 'Votre session a expiré. Veuillez vous reconnecter.',
    forbidden: 'Vous n\'avez pas la permission pour cette action.',
    notFound: 'La ressource demandée est introuvable',
    tooManyRequests: 'Trop de requêtes envoyées. Veuillez réessayer plus tard.',
    internalServerError: 'Erreur serveur. Veuillez réessayer plus tard.',
    badGateway: 'Serveur temporairement indisponible',
    serviceUnavailable: 'Service temporairement indisponible',
    gatewayTimeout: 'Le serveur ne répond pas',
    serverErrorWithStatus: 'Erreur serveur ({status})',
  },
  common: {
    databaseUnavailableDeveloperHint: 'Note développeur : en développement local, cela signifie souvent que le VPN est désactivé ou que votre IP n’est pas autorisée. Vérifiez le VPN et l’accès à la base de données.',
    ...coreMessages.common,
    requestTimeout: 'The request timed out. Please try again.',
    backendConnectionErrorDev: 'Impossible de se connecter au serveur backend. Assurez-vous que le serveur fonctionne ({apiUrl}).',
    backendConnectionErrorProd: 'Impossible de se connecter au serveur backend. Veuillez réessayer plus tard.',
    systemUpdating: 'Mise à jour du système...',
    serverConfiguring: 'Le serveur est en cours de configuration, veuillez patienter...',
    forbidden: 'Access denied.',
    network: 'Network error.',
    select: 'Sélectionner',
    cancel: 'Annuler',
    save: 'Enregistrer',
    saving: 'Enregistrement...',
    edit: 'Modifier',
    view: 'Consulter',
    copy: 'Copier',
    delete: 'Supprimer',
    appLauncher: 'Applications',
    allApps: 'Toutes les applications',
    loading: 'Chargement...',
    noData: 'Aucune donnée',
    code: 'Code',
    profileMenu: 'Menu du profil',
    selectLanguage: 'Sélectionner la langue',
    perPage: 'Par page',
    firstPage: 'Première page',
    previousPage: 'Page précédente',
    nextPage: 'Page suivante',
    lastPage: 'Dernière page',
    pleaseWait: 'Veuillez patienter',
    migrationDescription: 'Mise à jour de la base de données en cours. Cela peut prendre quelques secondes.',
    changeText: 'Modifier',
    deleteLogo: 'Supprimer le logo',
    logoUploadHint: 'Taille max : 5 Mo. Formats : JPEG, PNG, GIF, WebP',
    deleteAvatar: 'Supprimer la photo de profil',
    avatarUploadHint: 'Max 5 Mo. JPEG, PNG, GIF, WebP.',
    newRecord: 'Nouvel enregistrement',
    noPermission: 'Vous n\'avez pas la permission',
    searchPlaceholder: 'Rechercher...',
    allStatuses: 'Tous les statuts',
    active: 'Actif',
    inactive: 'Inactif',
    clearFilters: 'Effacer les filtres',
    all: 'Tout',
    clickToChangeStatus: 'Cliquez pour changer le statut',
    noChangePermission: 'Vous n\'avez pas la permission de changer le statut',
    statusDistribution: 'Répartition du statut',
    hide: 'Masquer',
    show: 'Afficher',
    companies: 'Companies',
    adminConsole: 'Console d\'administration',
    manageAccount: 'Gérer votre compte',
    manageYourAccount: 'Gérer votre compte',
    notificationsTitle: 'Notifications',
    notificationsUnread: 'non lues',
    notificationsTypesMuted: 'types en sourdine',
    notificationsViewAll: 'Tout voir',
    notificationsPreferences: 'Préférences',
    notificationsMutedLabel: 'En sourdine',
    notificationsEmpty: 'Aucune notification',
    selectAll: 'Tout sélectionner',
    id: 'ID',
    remove: 'Retirer',
    syncDeletedResult: '{count} entrées orphelines supprimées.',
    distributionByTable: 'Répartition par table (contexte)',
    distributionByLocale: 'Répartition par langue',
    translationReport: 'Distribution de l\'état des traductions',
    page: 'Page',
    rows: 'lignes',
    actions: 'Actions',
    create: 'Créer',
    search: 'Rechercher',
    closeSearch: 'Fermer la recherche',
    help: 'Aide',
    helpCenter: 'Centre d\'aide',
    helpAboutPage: 'À propos de cette page',
    helpDocumentation: 'Documentation',
    helpKeyboardShortcuts: 'Raccourcis clavier',
    helpWhatsNew: 'Nouveautés',
    helpF1Hint: 'Appuyez sur F1 pour obtenir de l’aide sur cette page',
    helpNoDocsForPage: 'La documentation de cette page n’est pas encore disponible',
    aiAssistantTitle: 'Assistant IA QubePro',
    aiAssistantButton: 'Assistant IA',
    aiAssistantUnavailable: 'L’assistant IA est actuellement indisponible.',
    appearancePreference: 'Préférence d’affichage',
    modalControlPlacement: 'Disposition des contrôles du formulaire',
    modalControlPlacementHint: 'Définit la position des contrôles de fermeture et de plein écran des formulaires.',
    modalControlPlacementSystem: 'Système (recommandé)',
    modalControlPlacementWindows: 'Windows',
    modalControlPlacementMacos: 'macOS',
    productTour: {
      start: 'Démarrer la visite du produit',
      restart: 'Relancer la visite du produit',
      navigationTitle: 'Barre latérale et modules',
      navigationDescription: 'Utilisez la barre latérale pour accéder aux modules et pages autorisés et déployer ou réduire chaque section.',
      appsTitle: 'Applications',
      appsDescription: 'Ouvrez vos applications QubePro et passez de l’une à l’autre ici.',
      profileTitle: 'Profil et entreprise',
      profileDescription: 'Gérez ici votre profil, l’entreprise sélectionnée et vos préférences linguistiques.',
      aiTitle: 'QubePro AI',
      aiDescription: 'Ouvrez l’assistant IA QubePro pour obtenir de l’aide sur la page actuelle.',
      helpTitle: 'Centre d’aide',
      helpDescription: 'Ouvrez la documentation ou relancez cette visite du produit à tout moment.',
      next: 'Suivant',
      previous: 'Précédent',
      done: 'Terminer',
      close: 'Fermer',
      neverShowAgain: 'Ne plus afficher automatiquement',
      progress: '{{current}} / {{total}}',
    },
    userExtensions: 'Extensions',
    close: 'Fermer',
    modalFocus: 'Centrer sur le formulaire',
    modalFullscreen: 'Passer en plein écran',
    modalRestore: 'Rétablir la taille',
    filterByColumn: 'Filtrer par {column}',
    formCustomFieldsLoading: 'Chargement des champs personnalisés…',
    formCustomFieldsLoadError: 'Impossible de charger les champs personnalisés. Réessayez avant d’enregistrer pour éviter toute perte de données.',
    formCustomFieldsRetry: 'Réessayer',
    pageUnavailableTitle: 'La page n’a pas pu être ouverte',
    pageUnavailableMessage: 'Vous pouvez ouvrir une autre page dans le menu ou actualiser cette page.',
    pageReloadWarning: 'L’actualisation efface les modifications non enregistrées.',
    allTargetLanguages: 'Toutes les langues (10 langues)',
    darkMode: 'Mode sombre',
    lightMode: 'Mode clair',
    errorOccurred: 'Une erreur s\'est produite',
    confirm: 'Confirmer',
    context: 'Tableau',
    key: 'Colonne',
    originalShort: 'Orig.',
    originalValue: 'Valeur originale',
    locale: 'Langue',
    value: 'Valeur',
    status: 'Statut',
    auto: 'Auto',
    manual: 'Manuel',
    manageLocales: 'Gérer les langues',
    updateUntranslatedFields: 'Synchroniser les nouveaux champs',
    autoTranslate: 'Traduction automatique',
    sourceAndTargetMustDiffer: 'La langue source et la cible doivent être différentes.',
    autoTranslateSuccessCount: '{count} éléments traduits automatiquement.',
    syncEntriesResult: '{count} nouvelles entrées de traduction synchronisées.',
    translated: 'Translated',
    missing: 'Manquant',
    autoTranslateScope: 'Portée de la traduction automatique',
    updateUntranslatedFieldsHint: 'Cliquez sur "Mettre à jour les nouveaux champs" pour synchroniser le contenu de ces tables.',
    processing: 'Traitement...',
    enterTargetLanguage: 'Choisir la langue cible.',
    sourceLanguage: 'Langue source',
    selectLanguagesFirst: 'Sélectionnez d\'abord les langues dans Gérer les langues',
    sourceLanguageLabel: 'Langue source (votre interface)',
    targetLanguage: 'Langue cible',
    activeLocalesDescription: 'Sélectionner les langues actives. Enregistré comme paramètre uniquement.',
    selectSourceLanguageForSync: 'Dans quelle langue sont les contenus ?',
    languageNames: {
      en: 'Anglais',
      tr: 'Turc',
      de: 'Allemand',
      fr: 'Français',
      es: 'Espagnol',
      ar: 'Arabe',
      it: 'Italien',
      ja: 'Japonais',
      zh: 'Chinois',
      ru: 'Russe',
    },
    warning: 'Avertissement',
  },
  login: {
    ...coreMessages.login,
    loginFailed: 'Échec de la connexion',
    emailRequired: 'L\'adresse e-mail est requise',
    passwordRequired: 'Le mot de passe est requis',
    backendUnavailable: 'Le serveur est indisponible. Veuillez réessayer plus tard.',
    backendConnectFailed: 'Connexion au serveur impossible. Veuillez réessayer plus tard.',
    backendConnectFailedDev: 'Connexion au serveur impossible. Vérifiez que le serveur est démarré ({apiUrl}).',
    emailLabel: 'E-mail',
    emailPlaceholderFull: 'Veuillez entrer votre e-mail',
    passwordLabel: 'Mot de passe',
    passwordPlaceholderFull: 'Entrez le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    showPassword: 'Afficher le mot de passe',
    loggingIn: 'Connexion en cours...',
    submitButton: 'Connexion',
    errors: {
      ...coreMessages.login.errors,
      invalidCredentials: 'E-mail ou mot de passe incorrect. Veuillez réessayer.',
      sessionTooLarge: 'Les données de session sont trop volumineuses. Veuillez vous reconnecter.',
      databaseUnavailable: 'La base de données est indisponible ou une configuration est requise. Veuillez vous reconnecter.',
      accountInactive: 'Votre compte n\'est pas actif. Veuillez contacter votre administrateur système.',
      sessionExpired: 'Votre session a expiré. Veuillez vous reconnecter.',
      tooManyAttempts: 'Trop de tentatives. Veuillez réessayer plus tard.',
    },
    featureTitle: "Reliez vos données opérationnelles et financières",
    featureDescription: "Suivez les stocks, achats, ventes et données financières avec QubePro ERP.",
    featureCard1Title: "Produits et stocks",
    featureCard1Description: "Gérez les produits, entrepôts et mouvements de stock.",
    featureCard2Title: "Achats",
    featureCard2Description: "Suivez les documents et commandes d’achat.",
    featureCard3Title: "Documents de vente",
    featureCard3Description: "Gérez les commandes clients et factures.",
    featureCard4Title: "Mouvements financiers",
    featureCard4Description: "Consultez les opérations bancaires, de caisse et financières.",
    darkMode: 'Mode sombre',
    lightMode: 'Mode clair',
    pleaseWait: 'Veuillez patienter',
    serverConfiguring: 'Configuration du serveur en cours...',
    dbCreating: 'Création de la base de données et des configurations. Cela peut prendre quelques secondes.',
    loginPageTitle: 'Connexion',
    languageToggleLabel: 'Choix de la langue',
  },
  sidebar: {
    ...coreMessages.sidebar,
    dashboard: 'Tableau de bord',
    settings: 'Paramètres',
    toggleMenu: 'Ouvrir le menu',
    toggleMenuClose: 'Fermer le menu',
    companies: 'Entreprises',
    logout: 'Déconnexion',
    activityLogs: "Journaux d'activité",
  },
  customFields: {
    title: 'Champs personnalisés',
    newField: 'Nouveau champ personnalisé',
    editField: 'Modifier le champ personnalisé',
    entityType: "Type d'enregistrement",
    code: 'Code du champ',
    label: 'Nom affiché',
    codePlaceholder: 'ex. niveauRisque',
    labelPlaceholder: 'ex. Code spécial 1',
    dataType: 'Type de données',
    type: 'Type',
    scope: 'Périmètre',
    companyId: 'ID société',
    companySelection: 'Sociétés',
    companySelectionPlaceholder: 'Vide = global, ou sélectionnez des sociétés',
    selectedCompanies: '{{count}} sociétés sélectionnées',
    selectAllCompanies: 'Sélectionner toutes les sociétés',
    sortOrder: 'Ordre',
    required: 'Obligatoire',
    searchable: 'Recherchable',
    showInForm: 'Afficher dans le formulaire',
    showInList: 'Afficher la colonne',
    formTab: 'Onglet du formulaire',
    formTabSelect: 'Onglet du formulaire',
    formTabPlaceholder: 'Vide utilise l’onglet Champs personnalisés',
    defaultCustomTab: 'Champs personnalisés',
    selectEntityTypeFirst: 'Sélectionnez d’abord le type',
    newFormTab: 'Nouvel onglet',
    tabCode: 'Code onglet',
    tabName: 'Nom onglet',
    tabCodePlaceholder: 'ex. operations',
    tabNamePlaceholder: 'ex. Données opérationnelles',
    fieldWidth: 'Disposition de ligne',
    widthFull: '1 champ par ligne',
    widthHalf: '2 champs par ligne',
    widthThird: '3 champs par ligne',
    widthQuarter: '4 champs par ligne',
    systemField: 'Champ système',
    description: 'Description',
    options: 'Options',
    optionsPlaceholder: 'Chaque ligne : code:Libellé\nEx. draft:Brouillon\nou seulement Brouillon',
    defaultValue: 'Valeur par défaut',
    statusDistributionTitle: 'Répartition des statuts - {{title}}',
    emptyMessage: 'Aucun champ personnalisé défini.',
    globalScope: 'Global',
    companyScope: 'Société {{id}}',
    deleteSelected: 'Supprimer la sélection',
    deleteSelectedMessage: '{{count}} champs personnalisés seront supprimés. Cette action est irréversible.',
    formDesigner: 'Conception du formulaire',
    formDesignerTitle: 'Conception des champs personnalisés',
    formDesignerEntityType: 'Type d’enregistrement à concevoir',
    formDesignerAllTabs: 'Tous',
    formDesignerEmpty: 'Aucun champ personnalisé pour ce type d’enregistrement.',
    formDesignerOriginalNotice: 'Les champs d’origine du formulaire sont préservés ; cet écran gère les onglets, l’ordre et la disposition des champs personnalisés.',
    formDesignerSave: 'Enregistrer la conception',
    formDesignerSaved: 'Conception du formulaire enregistrée.',
    formDesignerMoveUp: 'Déplacer vers le haut',
    formDesignerMoveDown: 'Déplacer vers le bas',
    formDesignerFieldSettings: 'Disposition du champ',
    formDesignerQuickSave: 'Enregistrer',
    formDesignerEditTab: 'Modifier l’onglet',
    formDesignerDeleteTab: 'Supprimer l’onglet',
    formDesignerTabEditorTitle: 'Paramètres de l’onglet',
    formDesignerCloseTabEditor: 'Fermer l’éditeur d’onglet',
    dataTypes: {
      text: 'Texte',
      number: 'Nombre',
      date: 'Date',
      datetime: 'Date/heure',
      boolean: 'Oui/Non',
      select: 'Sélection',
      json: 'JSON',
    },
  },
  activityLogs: {
    title: "Journaux d'activité",
    searchPlaceholder: 'Rechercher (entité, module, action)…',
    allModules: 'Tous les modules',
    allActions: 'Toutes les actions',
    allSeverity: 'Tous les niveaux de gravité',
    allApps: 'Toutes les applications',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    exportCsv: 'Exporter en CSV',
    total: 'Total',
    today: "Aujourd'hui",
    critical: 'Critique',
    warning: 'Avertissement',
    severityInfo: 'Info',
    exportFilenameStem: 'journaux-activite',
    noLogs: "Aucun journal d'activité trouvé.",   system: 'Système',
    field: 'Champ',
    oldValue: 'Ancienne valeur',
    newValue: 'Nouvelle valeur',
    ip: 'IP',
    meta: 'Métadonnées de requête',
    userAgent: 'User-Agent',
    entity: 'Entité',
    severityCol: 'Gravité',
    userCol: 'Utilisateur',
    actionCol: 'Action',
    moduleCol: 'Module',
    dateCol: 'Date',
    appCol: 'Application',
    overviewTitle: "Vue d'ensemble",
    severityChart: 'Répartition des gravité',
    topModulesChart: 'Principaux modules par volume',
    csvId: 'ID',
    csvDate: 'Date',
    csvUser: 'Utilisateur',
    csvAction: 'Action',
    csvModule: 'Module',
    csvEntity: 'Entité',
    csvSeverity: 'Gravité',
    csvIp: 'IP',
    csvApplication: 'Application',
    companyCol: 'ID société',
    allOutcomes: 'Tous les résultats',
    noLogsDesc: 'Les journaux apparaîtront ici lorsque les utilisateurs effectueront des actions.',
    entityType: 'Type d’enregistrement',
    actorType: 'Type d’acteur',
    outcome: 'Résultat',
    successful: 'Réussi',
    failed: 'Échoué',
    denied: 'Refusé',
    reason: 'Motif',
    requestId: 'ID de requête',
    correlationId: 'ID de corrélation',
    integrity: 'Preuve d’intégrité',
    outboxWarning: 'La file de livraison d’audit nécessite une intervention.',
  },

  // Header Notifications page
  headerNotifications: {
    tabNotifications: 'Notifications',
    tabPreferences: 'Préférences',
    markAllRead: 'Tout marquer comme lu',
    notifCount: '{total} notifications',
    unreadCount: '{count} non lues',
    loading: 'Chargement des notifications...',
    noNotifications: 'Aucune notification',    markRead: 'Marquer comme lu',
    delete: 'Supprimer',   noPreferences: 'Aucune préférence',
    noPreferencesDesc: 'Aucune catégorie de notification trouvée. Les préférences sont créées automatiquement lors de la réception de notifications.',
    preferencesHeader: 'Préférences de notifications in-app',
    prefItemDesc: 'Recevoir les notifications de cette catégorie dans l\'application',
    readDistribution: 'Répartition du statut de lecture',
    readStatusLabel: 'Statut de lecture',
    filterAll: 'Tous',
    filterUnread: 'Non lues',
    filterRead: 'Lues',    colType: 'Type',
    colTitle: 'Titre',
    colMessage: 'Message',
    colDate: 'Date',
    colRead: 'Statut',
    statusUnread: 'Non lu',
    statusRead: 'Lu',
    searchNotifications: 'Rechercher dans le titre ou le message…',
  },
};
